module.exports = __webpack_public_path__ + "img/go-right.9f37bb01.svg";